/**
 * @Author:
 * @Description:
 * @DateTime: Created in 2021-03-24 19:47:13
 */

import * as Vue from 'vue-tsx-support';
import { Component, Prop } from 'vue-property-decorator';
import 'vue-tsx-support/enable-check';
import Modal from 'src/types/iview/Modal';
import Button from 'src/types/iview/Button';
import Input from 'src/types/iview/Input';
import { Toast } from 'src/util/toast';
import { modalFactory } from 'src/util/vueExtend';
import EnumOperates from 'src/enums/enumOperates';
import { Integer } from 'src/types/base';
import EntitySelect from 'src/components/SelectCustom/entitySelect';
import EnumEntity from 'src/enums/enumEntity';
import { createNamespace } from 'src/util/bem';
import CompareNoticeApi from './api/compareNoticeApi';
import { DateTimeUtil } from 'src/util/dateTimeUtil';
import  DatePicker from 'src/types/iview/DatePicker';

export namespace OperateCompareNoticeVOI {
    export interface PropsI {
        operate: string;
        id?: number;

        saveSuccess?(): void;

        cancel?(): void;
    }

    export interface FormDataI {
        id?: Integer;
        dispose_company_id: Integer;
        comparison_site: { deviceId: Integer; components: string[]; key?: number; content: string }[];
        timestamp: Integer;
    }
}
let uid = 1;
@Component
class OperateCompareNoticeModal extends Vue.Component<OperateCompareNoticeVOI.PropsI> {
    @Prop({
        type: Function,
    })
    cancel!: () => void;

    @Prop({
        type: Number,
    })
    id!: number;

    @Prop({
        type: String,
    })
    operate!: string;

    @Prop({
        type: Function,
    })
    saveSuccess!: () => void;

    visible: boolean = false;

    loading: boolean = false;

    formData: OperateCompareNoticeVOI.FormDataI = {
        dispose_company_id: null,
        comparison_site: [{ deviceId: null, components: [], key: 0, content: '' }],
        timestamp: null,
    };
    rules: any = {
        name: [{ required: true, message: '请输入名称', trigger: 'change' }],
    };

    close() {
        this.cancel && this.cancel();
        this.closeModal();
    }

    closeModal() {
        this.visible = false;
        this.$emit('close', false);
    }

    async save() {
        if (!(await this.$validate('formValidate'))) {
            return;
        }
        let res;
        this.loading = true;
        this.formData.timestamp = DateTimeUtil.getSecondFromIviewDate(this.formData.timestamp)
        let params = {
            ...this.formData,
            comparison_site: {
                data: this.formData.comparison_site.map(i => ({
                    operational_equipment: i.components,
                    operational_site: i.deviceId,
                    operational_content: i.content
                })),
            },
        };
        switch (this.operate) {
            case EnumOperates.Add.getName():
                res = await CompareNoticeApi.add(params);
                break;
            case EnumOperates.Update.getName():
                params.id = this.id
                res = await CompareNoticeApi.update(params);
                break;
        }
        this.loading = false;
        let { code } = res;
        if (code === 0) {
            Toast.success(this.operate + '成功');
            this.saveSuccess();
            this.closeModal();
        }
    }
    genKey() {
        return uid++;
    }
    add(index: number) {
        this.formData.comparison_site.splice(index + 1, 0, { deviceId: null, components: [], key: this.genKey(), content: '' });
    }
    sub(index: number) {
        this.formData.comparison_site.splice(index, 1);
    }
    get searchCompanyParams() {
        return {device_ids: this.formData.comparison_site.map(i=> i.deviceId).filter(Boolean)};
    }
    async mounted() {
        if (this.operate !== EnumOperates.Add.getName()) {
            let { code, data } = await CompareNoticeApi.searchDetail({ id: this.id });
            if (code === 0) {
                this.formData = {
                    dispose_company_id: data.dispose_company_id,
                    comparison_site: data.comparison_site.data.map(i => ({
                        deviceId: i.operational_id,
                        components: i.operational_equipment,
                        key: this.genKey(),
                        content: i.operational_content
                    })),
                };
            }
        }
    }
    render(h) {
        return (
            <Modal title={this.operate + '对比通知'} width="800" v-model={this.visible} mask-closable={false} on-on-cancel={this.close}>
                <i-form ref="formValidate" labelWidth={100} model={this.formData} rules={this.rules}>
                    {this.formData.comparison_site.map((i, index) => {
                        return (
                            <div key={i.key}>
                                <form-item
                                    label="对比站点"
                                    prop={`comparison_site.${index}.deviceId`}
                                    required
                                    type="number"
                                    style="display: inline-block;width:40%"
                                >
                                    <EntitySelect
                                        type={EnumEntity.Station.getId()}
                                        v-model={i.deviceId}
                                        on-change={() => {
                                            i.components = [];
                                            this.formData.dispose_company_id;
                                        }}
                                    />
                                </form-item>
                                <form-item
                                    label="对比设备"
                                    prop={`comparison_site.${index}.components`}
                                    required
                                    type="array"
                                    style="display: inline-block;width:40%"
                                >
                                    <EntitySelect
                                        useNameAsId
                                        type={EnumEntity.ComponentById.getId()}
                                        v-model={i.components}
                                        searchParams={{ id: i.deviceId }}
                                        multiple
                                    />
                                </form-item>
                                <form-item label="" labelWidth={10} required type="number" style="display: inline-block;width:15%">
                                    <img
                                        on-click={this.add.bind(this, index)}
                                        src={require('../../../assets/images/add.png')}
                                        height="32px"
                                        class={createNamespace('mr10')}
                                    />
                                    <img
                                        on-click={this.sub.bind(this, index)}
                                        v-if={this.formData.comparison_site.length > 1}
                                        src={require('../../../assets/images/sub.png')}
                                        height="32px"
                                    />
                                </form-item>
                                <form-item
                                    label="对比内容"
                                    prop={`comparison_site.${index}.content`}
                                    required
                                    style="display: inline-block;width:95%"
                                >
                                    <Input placeholder="请输入" v-model={i.content} type="textarea" />
                                </form-item>
                            </div>
                        );
                    })}
                    <form-item
                        label="处理单位"
                        prop="dispose_company_id"
                        required
                        type="number"
                        style="display: inline-block;width:45%"
                    >
                        <EntitySelect
                            searchParams={this.searchCompanyParams}
                            type={EnumEntity.Company.getId()}
                            v-model={this.formData.dispose_company_id}
                        />
                    </form-item>
                    <form-item label="发起时间" prop="timestamp" required type="date" style="display: inline-block;width:45%">
                        <DatePicker editable placeholder="请选择" type="datetime" v-model={this.formData.timestamp} />
                    </form-item>
                </i-form>
                <div slot="footer">
                    <Button type="primary" ghost on-click={this.close}>
                        取消
                    </Button>
                    <Button type="primary" on-click={this.save} loading={this.loading}>
                        保存
                    </Button>
                </div>
            </Modal>
        );
    }
}

export default function alertOperateCompareNoticeModal(operate: string, id?: number): Promise<boolean> {
    return new Promise((resolve, reject) => {
        modalFactory<OperateCompareNoticeVOI.PropsI>(OperateCompareNoticeModal)({
            id,
            operate,
            saveSuccess() {
                resolve(true);
            },
            cancel() {
                resolve(false);
            },
        });
    });
}
